import { Card, CardBody, Col, Container, Input, Label, Row, Table, Pagination, PaginationItem, PaginationLink, CardHeader } from "reactstrap";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useEffect, useState } from "react";
import { SearchTableButton } from "../../utils/Constant";
import { URL_API } from "../../utils/helper/helpers";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import { Badges, H5, H6 } from "../../AbstractElements";
import { formatDate, formatPhoneNumber, formatPrice, truncateText } from "../../utils/helper/helpers";
import { CardFooter } from 'reactstrap';

type Produit = {
    libelle: string;
    prix_unitaire: number;
    quantite_stock: number;
    total_montant_entree: number;
    total_quantite_entree: number;
    total_montant_sortie: number;
    total_quantite_sortie: number;
    status: string;
};

interface Detail {
    date: string;
    type: string;
    quantite: number;
    prix_unitaire?: number;
    prix_total?: number;
    description?: string;
}

const ShowProduits = () => {
    const { id } = useParams<{ id: string }>();
    const [filterText, setFilterText] = useState("");
    const [filteredVentes, setFilteredVentes] = useState<Detail[]>([]);
    const [produit, setProduit] = useState<Produit | null>(null);
    const [details, setDetails] = useState<Detail[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [filter, setFilter] = useState<string>('all');
    const [typeFilter, setTypeFilter] = useState<string>('all'); // État pour le filtre par type
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const Token = JSON.parse(localStorage.getItem("login")!);

    // Pagination states
    const [currentPage, setCurrentPage] = useState<number>(1);
    const itemsPerPage = 10;

    const filterDetails = () => {
        const today = new Date();
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - today.getDay());
        const endOfWeek = new Date(today);
        endOfWeek.setDate(today.getDate() + (6 - today.getDay()));
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;

        const filtered = Array.isArray(details) ? details.filter(item => {
            const itemDate = new Date(item.date);
            let dateMatch = true; // Par défaut, on considère que la date correspond
            let typeMatch = true; // Par défaut, on considère que le type correspond
            let searchMatch = true; // Par défaut, on considère que la recherche correspond

            // Vérifiez la correspondance de date
            switch (filter) {
                case 'today':
                    dateMatch = itemDate.toDateString() === today.toDateString();
                    break;
                case 'week':
                    dateMatch = itemDate >= startOfWeek && itemDate <= endOfWeek;
                    break;
                case 'month':
                    dateMatch = itemDate >= startOfMonth && itemDate <= endOfMonth;
                    break;
                case 'interval':
                    dateMatch = start !== null && end !== null && itemDate >= start && itemDate <= end;
                    break;
                default:
                    dateMatch = true;
            }

            // Filtre par type
            if (typeFilter !== 'all') {
                typeMatch = item.type === typeFilter;
            }

            // Filtre par recherche
            if (filterText) {
                searchMatch = item.description?.toLowerCase().includes(filterText.toLowerCase()) || false;
            }

            return dateMatch && typeMatch && searchMatch; // Retournez le résultat de la vérification
        }) : [];

        setFilteredVentes(filtered);
    }

    useEffect(() => {
        const fetchProduit = async () => {
            try {
                const response = await axios.get(`${URL_API}/produit/get/${id}`, {
                    headers: {
                        Authorization: `Bearer ${Token}`
                    }
                });

                if (response.data.success) {
                    setProduit(response.data.produit);
                    setDetails(response.data.details);
                }
            } catch (error: any) {
                if (error.response && !error.response.data.success) {
                    toast.info(error.response.data.message);
                } else {
                    toast.error("Erreur lors du chargement du produit.");
                }
                setError("Erreur lors du chargement du produit.");
            } finally {
                setLoading(false);
            }
        };
        fetchProduit();
    }, [id]);

    useEffect(() => {
        filterDetails();
    }, [details, filter, startDate, endDate, typeFilter, filterText]); // Ajoutez filterText ici

    // Handle pagination
    const totalPages = Math.ceil(filteredVentes.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredVentes.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber: number) => setCurrentPage(pageNumber);
    if (loading) return <p>Chargement...</p>;
    if (error) return <p>{error}</p>;


    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Details" parent="Produits" />
            <Container fluid>
                <Row>
                    <Col md="5">
                        <Row>
                            <Col sm="6">
                                <Card className="progress-items pb-4">
                                    <CardHeader className="pb-0">
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <H5 className="f-18 fw-bolder text-capitalize">
                                                    Stock Total
                                                </H5>
                                                <span className="f-20 f-w-600 mt-3">
                                                    {produit?.total_quantite_entree.toLocaleString("gn-GN")} Produits
                                                </span > <br />
                                                <span className="f-16 ">
                                                    {produit?.total_quantite_sortie.toLocaleString("gn-GN")} Produits
                                                </span>
                                            </div>
                                        </div>
                                    </CardHeader>
                                </Card>
                            </Col>
                            <Col sm="6">
                                <Card className="progress-items pb-4">
                                    <CardHeader className="pb-0">
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <H5 className="f-18 fw-bold text-capitalize">
                                                    Montant Total
                                                </H5>
                                                <span className="f-20 f-w-600 mt-3">
                                                    <i data-feather="trending-down"></i> {formatPrice(produit?.total_montant_entree)}
                                                </span > <br />
                                                <span className="f-16 ">
                                                    {formatPrice(produit?.total_montant_sortie)}
                                                </span>
                                            </div>
                                        </div>
                                    </CardHeader>
                                </Card>
                            </Col>
                        </Row>

                        <Card>
                            <CardBody>
                                <Table bordered responsive className="text-center">
                                    <thead>
                                        <tr>
                                            <th scope="col">NOM</th>
                                            <th scope="col">PRIX UNITAIRE</th>
                                            <th scope="col">QUANTITE STOCK</th>
                                            <th scope="col">STATUS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {produit && (
                                            <tr>
                                                <td>{produit.libelle}</td>
                                                <td>{formatPrice(produit.prix_unitaire)}</td>
                                                <td>{produit.quantite_stock}</td>
                                                <td>
                                                    {produit.status === 'disponible' ? (
                                                        <Badges color="light-success">{produit.status}</Badges>
                                                    ) : (
                                                        <Badges color="light-danger">{produit.status}</Badges>
                                                    )}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="7">
                        <Card>
                            <CardBody>
                                <div className="filter-section">
                                    <Row>
                                        <Col sm="6">
                                            <Label for="filter">Filtre Date :</Label>
                                            <Input
                                                type="select"
                                                className="form-control"
                                                id="filter"
                                                value={filter}
                                                onChange={(e) => setFilter(e.target.value)}
                                            >
                                                <option value="all">Tous</option>
                                                <option value="today">Aujourd'hui</option>
                                                <option value="week">Cette semaine</option>
                                                <option value="month">Ce mois</option>
                                                <option value="interval">Intervalle de dates</option>
                                            </Input>
                                        </Col>
                                        <Col sm="6">
                                            <Label for="typeFilter">Filtre Type :</Label>
                                            <Input
                                                type="select"
                                                className="form-control"
                                                id="typeFilter"
                                                value={typeFilter}
                                                onChange={(e) => setTypeFilter(e.target.value)}
                                            >
                                                <option value="all">Tous</option>
                                                <option value="approvisionnement">Approvisionnement</option>
                                                <option value="vente">Vente</option>
                                            </Input>
                                        </Col>
                                    </Row>
                                </div>
                            </CardBody>
                        </Card>

                        {filter === "interval" && (
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col sm={6}>
                                            <Label for="startDate">Début :</Label>
                                            <Input
                                                type="date"
                                                id="startDate"
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                            />
                                        </Col>
                                        <Col sm={6}>
                                            <Label for="endDate">Fin :</Label>
                                            <Input
                                                type="date"
                                                id="endDate"
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                            />
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        )}

                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm="12">
                                        <div className="dataTables_filter d-flex align-items-center">
                                            <Label className="me-2">{SearchTableButton}:</Label>
                                            <Input
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                type="search"
                                                value={filterText}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>

                            <div className={`theme-scrollbar table-responsive table table-striped bg-info text-center`}>

                                <Table striped={true} hover={true} size={'sm'} responsive={"sm"}>
                                    <thead className={`tbl-strip-thad-bdr`}>
                                        <tr>
                                            <th scope="col">#Id</th>
                                            <th scope="col">Date</th>
                                            <th scope="col">Type</th>
                                            <th scope="col">Quantité</th>
                                            <th scope="col">Prix Unitaire</th>
                                            <th scope="col">Prix Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {currentItems.map((item, index) => (
                                            <tr key={index} className='text-center'>
                                                <th scope='row'>
                                                    <span className="fw-bold text-dark">
                                                        #{index + 1}
                                                    </span>
                                                </th>
                                                <td style={{ textAlign: "center" }}>
                                                    <span className="fw-bold text-dark text-capitalize">
                                                        {formatDate(new Date(item.date))}
                                                    </span>
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    <span className="fw-bold text-dark text-capitalize">
                                                        {item.type}
                                                    </span>
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    <span className="fw-bold text-dark text-capitalize">
                                                        {item.quantite.toLocaleString("gn-GN")}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-dark text-capitalize">
                                                        {formatPrice(item.prix_unitaire)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-dark text-capitalize">
                                                        {formatPrice(item.prix_total)}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>

                            </div>
                            {totalPages > 1 && (
                                <CardFooter>
                                    <Pagination>
                                        {[...Array(Math.ceil(filteredVentes.length / itemsPerPage))].map((_, i) => (
                                            <PaginationItem key={i} active={i + 1 === currentPage}>
                                                <PaginationLink onClick={() => paginate(i + 1)}>
                                                    {i + 1}
                                                </PaginationLink>
                                            </PaginationItem>
                                        ))}
                                    </Pagination>
                                </CardFooter>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>

    );
};

export default ShowProduits;
